
/*import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
import QrcodeVue from 'qrcode.vue'
/*import {AppService} from '../../../../providers/AppService.js';
const appService = new AppService();*/
export default {
    name: "Qrcode",
     data () {
    return {
      tabs: null,
      dialoText: 'chargement en cours...',
      dialogTitle:'',
      titre:'',
      webFlow: "",
      ariadNextUrl: 200,
      showWait: true,
      message:'',
      qrcodeType:'',      
      qrcodeSize: "200",

    }
  },components: {
    QrcodeVue,
  },
  mounted: function () {
   
    this.getQrcode();
  },

  methods: {
    getQrcode: function(){
      //recuperation des variables get
       if(this.$root.token && this.$root.typeScan){ 
        this.qrcodeType = this.$root.typeScan;   
        if(this.qrcodeType == 'scan') {
          this.titre='Pièces justificatives';
          this.dialogText = "Scanner le qrcode ci-contre avec votre tablette afin d'uploader les documents";
          this.dialogTitle = "Upload des pièces justificatives";
          this.ariadNextUrl = document.location.protocol+location.host+"?token="+this.$root.token+"&redirect=souscription/progress/progressscan";
        }else{
          this.titre='Signature électronique';
          this.dialogText = "Scanner le qrcode avec votre tablette afin de signer les documents";
          this.dialogTitle = "Signature électronique";
          this.ariadNextUrl = document.location.protocol+location.host+"?token="+this.$root.token+"&redirect=souscription/progress/progresssign";
        }
         

        this.$dialog.warning({
          text: this.dialogText,
          title: this.dialogTitle,
          persistent: true
        });
        sessionStorage.clear();
       }else{
        this.$dialog.error({
          text: this.$root.errorMessage,
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
       }
      
    }
  }
}